import httpClient from "./httpClient";

const prefix = "/celebrity-days";

export interface CelebrityDayData {
  id: number;
  date: string; // YYYY-MM-DD format
  title: string;
  bonusType: string;
  createdAt: string;
  updatedAt: string;
}

export interface CelebrityDaysResponse {
  days: CelebrityDayData[];
}

export interface CreateCelebrityDayRequest {
  date: string;
  title: string;
  bonusType: string;
}

export interface UpdateCelebrityDayRequest {
  date?: string;
  title?: string;
  bonusType?: string;
}

export async function getCelebrityDays(): Promise<CelebrityDaysResponse> {
  return (await httpClient.get(`${prefix}`)).data;
}

export async function createCelebrityDay(data: CreateCelebrityDayRequest): Promise<CelebrityDaysResponse> {
  return (await httpClient.post(`${prefix}`, data)).data;
}

export async function updateCelebrityDay(id: number, data: UpdateCelebrityDayRequest): Promise<CelebrityDaysResponse> {
  return (await httpClient.patch(`${prefix}/${id}`, data)).data;
}

export async function deleteCelebrityDay(id: number): Promise<CelebrityDaysResponse> {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}

export async function deleteCelebrityDayByDate(date: string): Promise<CelebrityDaysResponse> {
  return (await httpClient.delete(`${prefix}/date/${date}`)).data;
}

export async function getCelebrityDay(id: number): Promise<CelebrityDayData> {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}
